import flussoLogo from "../assets/images/ValenzWhiteLogo.png";

export const Logo = () => {
	return (
		<>
			<img
				src={flussoLogo}
				height="35px"
				width="90px"
				style={{ marginLeft: "8px" }}
				alt="logo"
			/>
		</>
	);
};

export const LogoSmall = () => {
	return (
		<>
			<img src={flussoLogo} height="28px" width="28px" alt="logo" />
		</>
	);
};
